import styled from "@emotion/styled";

const Legend = styled.legend(({ theme }) => ({
  ...theme.fonts.body,
  display: "block",
  fontSize: theme.fontSizes.sm,
  fontWeight: "700",
  padding: 0,
  small: {
    fontWeight: "normal",
    fontSize: theme.fontSizes.xxs,
    fontStyle: "italic",
    opacity: "0.7",
  },
}));

export { Legend };
